import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RequirementBox from "../../components/RequirementBox";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Typography } from "@mui/material";

export default function StructuredEntries({
  moduleData,
  handleEditStructuredEntry,
  setSelectedModule,
  setToDeleteIdNameAndType,
}) {
  const { t } = useTranslation();

  const boxSxEntry = {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  };

  const boxSxEntryDetails = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };

  const emptyModule = {
    id: "",
    sortingNumber: 0,
    title: "",
  };

  return moduleData.structuredEntries.map((sData, sDataIndex) => (
    <>
      <Box
        key={sDataIndex}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          ml: 2.5,
          border: 0,
          borderBottom: 1,
          pb: 0.5,
          borderStyle: "dashed",
          mt: sDataIndex === 0 ? 0 : 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontStyle: "italic",
              pr: 1,
            }}
          >
            {t("question")} {sDataIndex + 1}
            {sData.title && `: ${sData.title}`}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{ width: 30, height: 30 }}
            onClick={(e) => handleEditStructuredEntry(e, sData)}
          >
            <EditIcon sx={{ width: 20, height: 20 }} />
          </IconButton>
          <IconButton
            sx={{
              width: 30,
              height: 30,
              mx: 1,
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedModule(emptyModule);
              setToDeleteIdNameAndType({
                id: sData.id,
                name: sData.title,
                type: "StructuredEntry",
              });
            }}
          >
            <DeleteForeverIcon sx={{ width: 20, height: 20 }} />
          </IconButton>
        </Box>
      </Box>
      <Typography sx={{ fontFamily: "Inter", ml: 3, mt: 1 }}>
        {`${sData.description} (${t("source")}: ${
          sData.source ? sData.source : t("none")
        })`}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontStyle: "italic",
          textDecoration: "underline",
          ml: 3,
          mt: 1,
          pr: 1,
        }}
      >
        {t("reqs:")}
      </Typography>
      {sData.entries.length === 0 && (
        <Typography
          sx={{
            alignSelf: "center",
            fontFamily: "Inter",
            fontSize: 14,
            mb: 1,
          }}
        >
          {t("noEntryDetails")}
        </Typography>
      )}
      {sData.entries.map((entryDetails, entryIndex) => (
        <Box
          key={entryIndex}
          sx={{
            display: "flex",
            flexDirection: "row",
            ml: 7,
            py: 1,
            borderBottom: 1,
          }}
        >
          <Box sx={boxSxEntry}>
            {Object.entries(entryDetails).map(([field, value]) => (
              <RequirementBox
                key={field}
                boxSx={boxSxEntryDetails}
                label={t(`${field}`) + ":"}
                data={value}
              />
            ))}
          </Box>
        </Box>
      ))}
    </>
  ));
}
